import {SyncTimesStaticTable} from '../sync-times-static.table';
import {Vehicle} from '../../interfaces/vehicles/vehicle';
import {db} from '../db.service';
import {Injectable} from '@angular/core';
import {ArrayHelper} from '../../helpers/array-helper';

@Injectable({
  providedIn: 'root'
})
export class VehiclesTable extends SyncTimesStaticTable<Vehicle> {

  /**
   *
   */
  constructor() {
    super(db.vehicles);
  }

  /**
   *
   * @param serviceFacilityId
   */
  public async getVehiclesByServiceFacilityId(serviceFacilityId: number): Promise<Vehicle[]> {
    const vehicles = await this.table.where('serviceFacilityId').equals(serviceFacilityId).toArray();
    return ArrayHelper.sort(vehicles, [
      { key: 'vehicleCategoryId', order: 'DESC' },
      { key: 'licensePlate', order: 'ASC' }
    ]);
  }

  /**
   *
   * @param serviceFacilityId
   */
  public deleteVehiclesByServiceFacilityId(serviceFacilityId: number): Promise<number> {
    return this.table.where('serviceFacilityId').equals(serviceFacilityId).delete();
  }
}

